/*
 * Creator strip: keeps moving on its own, but stays draggable.
 *
 * A CSS animation cannot do both. Once a transform is running, the element no
 * longer scrolls, so a swipe does nothing — which is exactly what went wrong.
 * Driving scrollLeft instead means the browser's own touch scrolling, momentum
 * and drag all keep working; this just nudges the same value along when nobody
 * is holding it.
 *
 * The photo set is rendered twice, so when the scroll passes the halfway mark
 * it is reset back by exactly half. The frame either side of that jump is
 * identical, so the loop is invisible and the strip never reaches an end.
 */
(function () {
  'use strict';

  var SPEED = 0.42;       /* px per frame, ~25px a second */
  var RESUME_AFTER = 2200; /* ms of stillness before it drifts again */

  function init(row) {
    if (row.dataset.pkMarquee) return;
    row.dataset.pkMarquee = '1';

    var paused = false;
    var timer = null;

    function holdStill() {
      paused = true;
      clearTimeout(timer);
      timer = setTimeout(function () { paused = false; }, RESUME_AFTER);
    }

    /* Any sign of a human: stop drifting and let them drive. Every one of
       these releases on a timer, so nothing can latch it off for good. */
    /* Deliberately NOT listening for 'scroll'. Our own nudge fires one every
       frame, and a scroll event is dispatched asynchronously — after any flag
       we set around the write has already been cleared. Listening for it made
       the strip pause itself on every tick. A human always arrives through one
       of the input events below first. */
    ['pointerdown', 'pointerup', 'touchstart', 'touchend', 'wheel'].forEach(function (evt) {
      row.addEventListener(evt, holdStill, { passive: true });
    });

    /* Hover-to-pause ONLY where hovering is a real thing. A phone fires a
       phantom mouseenter on tap and then never fires mouseleave, so an
       unguarded hover pause stops the strip permanently on the first touch —
       which is exactly what happened. */
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      row.addEventListener('mouseenter', function () { paused = true; });
      row.addEventListener('mouseleave', function () { paused = false; });
    }

    /* Keyboard focus holds it, but on the same timed release. */
    row.addEventListener('focusin', holdStill);

    function step() {
      var half = row.scrollWidth / 2;
      if (!paused && half > 0) row.scrollLeft += SPEED;
      /* Wrap in both directions so dragging backwards never hits a wall. */
      if (row.scrollLeft >= half) row.scrollLeft -= half;
      else if (row.scrollLeft <= 0) row.scrollLeft += half;
      requestAnimationFrame(step);
    }

    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      requestAnimationFrame(step);
    }
  }

  function boot() { document.querySelectorAll('.pk-inf__row').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
